import { Box, Color } from '@gousto-internal/citrus-react'
import React from 'react'
import type { IconButtonProps } from '../../../types/curatedBoxTypes'
import { AddIcon, AddIconTile } from './CuratedBoxRecipeTile.styled'

export const IconButton = ({ handleClick, handleOnKeyDown }: IconButtonProps) => (
  <Box
    data-testid="addCuratedBoxIconButton"
    tabIndex={0}
    onClick={handleClick}
    onKeyDown={handleOnKeyDown}
    borderRadius={1.5}
    bg={Color.White}
    paddingH={1}
    paddingV={1}
  >
    <AddIconTile>
      <AddIcon size={5} name="add" />
    </AddIconTile>
  </Box>
)
